const navigationFNS = [
  {
    title: true,
    name: "FNS",
    class: "",
    wrapper: {
      element: "",
      attributes: {}
    }
  },
  {
    name: "FNS Issues",
    url: "/base/IssuesPreviewOffice",
    icon: "icon-pencil"
  },
  {
    name: "FNS Issues Map",
    url: "/base/IssuesMapOffice",
    icon: "icon-map"
  }
];

export default navigationFNS;
